import React from 'react';
import { Container, Grid, useMediaQuery } from '@material-ui/core';
import SetNewPasswordForm from './components/SetNewPassword.form';
import { t } from 'src/i18n';
import { useCookies } from 'react-cookie';
import SuccessScreen from 'src/components/SuccessScreen/SuccessScreen';
import { Header } from './components/SetNewPassword.style';
import MainLogo from 'src/components/MainLogo/MainLogo';
import { parseJSON } from 'src/utils/common.util';
import TabletLogoBanner from 'src/assets/images/banner/tablet.png';
import DesktopLogoBanner from 'src/assets/images/banner/desktop.png';
import MobileLogoBanner from 'src/assets/images/banner/mobile.png';
import { AuthUtil } from 'src/utils';

interface IProps {
  setStepVerify(step: number): void;
}

const SetNewPasswordView: React.FC<IProps> = ({ setStepVerify }) => {
  const [isSetPasswordSuccessful, setSetPasswordSuccessful] = React.useState<
    boolean
  >(false);
  const [token, setToken] = React.useState<string>();
  const [contactId, setContactId] = React.useState<string>();

  const [, setCookie] = useCookies();

  const matches = useMediaQuery('(max-width:768px)');
  const isIpadLg = useMediaQuery('(max-width:1024px)');

  const isTablet = matches || isIpadLg;
  const isMobile = useMediaQuery('(max-width:600px)');

  let Logo = DesktopLogoBanner;

  if (isMobile) {
    Logo = MobileLogoBanner;
  } else if (isTablet) {
    Logo = TabletLogoBanner;
  }

  const postSetPasswordSuccessfulHandle = (returnedToken, returnContactId) => {
    setToken(returnedToken);
    setContactId(returnContactId);
  };

  const handleBackToSignIn = async () => {
    await AuthUtil.fetchCurrentUserInfo(token, (user) => {
      const expireDate = new Date();
      expireDate.setTime(expireDate.getTime() + 24 * 3600 * 1000);

      const {
        spouse,
        guardian_1,
        guardian_2,
        billing,
        role,
        primaryInsurance,
        secondaryInsurance,
        ...userInfo
      } = user;

      setCookie('token', token, {
        expires: expireDate,
        path: '/'
      });
      setCookie('contactId', contactId, {
        expires: expireDate,
        path: '/'
      });

      setCookie('userInfo', JSON.stringify(userInfo), {
        expires: expireDate,
        path: '/'
      });

      setCookie('spouse', JSON.stringify(spouse), {
        expires: expireDate,
        path: '/'
      });

      setCookie(
        'guardian',
        JSON.stringify({
          guardian_1,
          guardian_2
        }),
        {
          expires: expireDate,
          path: '/'
        }
      );

      setCookie('billing', JSON.stringify(billing), {
        expires: expireDate,
        path: '/'
      });

      setCookie('primaryInsurance', JSON.stringify(primaryInsurance), {
        expires: expireDate,
        path: '/'
      });

      setCookie('secondaryInsurance', JSON.stringify(secondaryInsurance), {
        expires: expireDate,
        path: '/'
      });

      setCookie('role', role, { expires: expireDate, path: '/' });

      sessionStorage.removeItem('guestSubmission');
    });
  };

  return (
    <Container className="login" maxWidth={false} disableGutters={true}>
      {isSetPasswordSuccessful ? (
        <>
          <Header>
            <MainLogo logoPath={(parseJSON('tenantInfo') as any).logoPath} />
          </Header>
          <SuccessScreen
            isShowSuccessIcon={true}
            isShowReturnIcon={false}
            titleMessage={t('setPassword.successful.title')}
            descriptionMessage={t('setPassword.successful.description')}
            buttonBackMessage={t('setPassword.successful.backToDashboard')}
            handleGoBack={handleBackToSignIn}
          />
        </>
      ) : (
        <Grid
          container={true}
          direction={isTablet ? 'row' : 'row-reverse'}
          className="login__left-wrapper"
        >
          <Grid
            item={true}
            sm={isTablet ? 12 : 7}
            className="login__right-container"
          >
            <img src={Logo} alt="Home Banner" className="login__banner" />
          </Grid>
          <Grid
            item={true}
            sm={isTablet ? 12 : 5}
            className="login__left-container"
          >
            <div className="login__logo-wrapper">
              <MainLogo logoPath={(parseJSON('tenantInfo') as any).logoPath} />
            </div>

            <div className="login__form-wrapper">
              <SetNewPasswordForm
                setStepVerify={setStepVerify}
                setSetPasswordSuccessful={setSetPasswordSuccessful}
                whenSetPasswordSuccessful={postSetPasswordSuccessfulHandle}
              />
            </div>
          </Grid>
        </Grid>
      )}
    </Container>
  );
};

export default SetNewPasswordView;
